import { ReactNode } from "react";
import { createRoutesFromElements, Navigate, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Startup from "./components/Startup";
import SSO from "./screens/SSO/SSO";
import ChangePassword from "./screens/change-password";
import ForgotPassword from "./screens/forget-password";
import Home from "./screens/home";
import Levels from "./screens/levels";
import Login from "./screens/login";
import Lookups from "./screens/lookups";
import NotFound from "./screens/not-found";
import Projects from "./screens/projects";
import RecoverEmail from "./screens/recover-email/RecoverEmail";
import Reports from "./screens/reports/index";
import ResetPassword from "./screens/reset-password";
import Companies from "./screens/companies";
import Users from "./screens/users";
import UserGroups from "./screens/user-groups";
import { isAuthorize } from "./utils/common";
import {
  ENGINEER,
  PROJECT_ADMIN,
  SUBCONTRACTOR,
  SUPER_ADMIN,
} from "./constants/roles";

const ProtectedRoute = ({
  children,
  allowedRoles,
}: {
  children: ReactNode;
  allowedRoles?: string[];
}) => {
  if (!isAuthorize(allowedRoles)) {
    return <Navigate to="/" />;
  }

  const user = localStorage.getItem("user");

  if (user) {
    return <>{children}</>;
  }

  return <Navigate to="/" />;
};

const routes = createRoutesFromElements(
  <Route path="/" element={<Startup />} errorElement={<ErrorBoundary />}>
    <Route index element={<Login />} errorElement={<ErrorBoundary />} />
    <Route path="/sso" element={<SSO />} errorElement={<ErrorBoundary />} />
    <Route
      path="/forgot-password"
      element={<ForgotPassword />}
      errorElement={<ErrorBoundary />}
    />
    <Route
      path="/recover-email"
      element={<RecoverEmail />}
      errorElement={<ErrorBoundary />}
    />
    <Route
      path="/reset-password"
      element={<ResetPassword />}
      errorElement={<ErrorBoundary />}
    />
    <Route
      path="/change-password"
      element={<ChangePassword />}
      errorElement={<ErrorBoundary />}
    />
    <Route
      path="/home"
      element={
        <ProtectedRoute
          allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN, ENGINEER, SUBCONTRACTOR]}
        >
          <Home />
        </ProtectedRoute>
      }
      errorElement={<ErrorBoundary />}
    />
    <Route path="*" element={<NotFound />} errorElement={<ErrorBoundary />} />
    <Route path="settings">
      <Route
        path="projects"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <Projects />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="levels"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <Levels />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="lookups"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <Lookups />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="users"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <Users />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="companies"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <Companies />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="user-groups"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN]}>
            <UserGroups />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="reports"
        element={
          <ProtectedRoute allowedRoles={[SUPER_ADMIN, PROJECT_ADMIN, ENGINEER, SUBCONTRACTOR]}>
            <Reports />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      />
    </Route>
  </Route>
);

export default routes;
